export default "__VITE_ASSET__BVa6luaK__"